import {Component, inject} from '@angular/core';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {take} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {LucideAngularModule} from 'lucide-angular';
import {AltchaComponent} from '@shared/altcha.component';
import {ResetPasswordRequest} from '@core/auth/auth.interfaces';
import {AuthService} from '@core/auth/auth.service';
import {PasswordFieldComponent} from '@shared/form/string/password-field/password-field.component';

@Component({
  selector: 'app-auth-reset-user-password',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    AltchaComponent,
    PasswordFieldComponent,
    LucideAngularModule,
    PasswordFieldComponent
  ],
  templateUrl: './reset-user-password.component.html'
})
export class ResetUserPasswordComponent {

  private readonly formBuilder = inject(FormBuilder);

  public readonly resetPasswordForm = this.formBuilder.group({
    captcha: ['', Validators.required],
    password: ['', Validators.required]
  });

  private readonly resetParams: ResetPasswordRequest;

  public constructor(
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute
  ) {
    this.resetParams = {
      username: route.snapshot.queryParams['data'],
      code: route.snapshot.queryParams['secret'],
      now: route.snapshot.queryParams['now'],
      hash: route.snapshot.queryParams['hash'],
      newPassword: '',
      captcha: ''
    };
  }

  public resetPassword() {
    this.resetParams.captcha = this.resetPasswordForm.controls.captcha?.value || '';
    this.resetParams.newPassword = this.resetPasswordForm.controls.password?.value || '';

    this.authService.resetPassword(this.resetParams).pipe(
      take(1)
    ).subscribe(_user => {});
  }
}
